export default function SuccessScreen({ nomineeName, onReset }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center px-4 py-5 mt-5">
      <div className="sidebar-trophy mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      <h1 className="mb-2">Nomination Submitted!</h1>
      <p className="mb-1 text-primary">
        Thank you.
      </p>
      <p className="mb-4 text-primary">
        Your nomination has been received and is under review.
      </p>
      <button onClick={onReset} className="btn btn-secondary-theme px-4">
        Nominate Someone Else
      </button>
    </div>
  );
}
